









import { computed, defineComponent } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import uploadFile from '@/gql/uploadFile.gql';

const CommonDropzoneWithFileUpload = defineComponent({
  props: {
    type: {
      type: String,
      validation: (input: string) => ['IMAGE', 'ARCHIVE'].indexOf(input) !== -1,
    },
  },
  setup(props, context) {
    const variables = computed(() => ({
      type: props.type,
    }));
    const mutation = useMutation(uploadFile);

    mutation.onDone((result) => {
      context.emit('done', result?.data.uploadFile);
    });

    return {
      mutation,
      variables,
    };
  },
});

export default CommonDropzoneWithFileUpload;
